import type React from 'react'

import { useNavigate, useParams } from '@tanstack/react-router'

import { Toaster } from '@/components/molecules/Toaster'
import { ChannelView } from '@/components/templates/ChannelView'
import { RegionProvider } from '@/model/contexts/RegionProvider'

import { useChannelPage } from './useChannelPage.ts'

const ChannelPageContent: React.FC = () => {
  const props = useChannelPage()
  const { regionId } = useParams({ from: '/dashboard/$regionId/messages/channels/$channelId' })
  const navigate = useNavigate()

  const onTeamMessageClick = (clickedTeamId: string) =>
    navigate({ to: '/dashboard/$regionId/messages/$teamId', params: { regionId, teamId: clickedTeamId } })

  // Carry the central: without it, a super admin supervising another one lands on the environment's
  // default central and the request they clicked is nowhere to be found.
  const onHighlight = (transportRequestId: string) =>
    navigate({ to: '/', search: { transportRequestId, central_id: props.piloteRegionId } })

  return (
    <>
      <Toaster onHighlight={onHighlight} onTeamMessageClick={onTeamMessageClick} />
      <ChannelView {...props} />
    </>
  )
}

export const ChannelPage: React.FC = () => {
  const { regionId } = useParams({ from: '/dashboard/$regionId/messages/channels/$channelId' })

  return (
    <RegionProvider regionId={regionId}>
      <ChannelPageContent />
    </RegionProvider>
  )
}
